import { CircleLayerSpecification, LineLayerSpecification, SymbolLayerSpecification } from 'mapbox-gl';

export const ROAD_MAP_TYPE = 'roadmap';
export const SATELLITE_MAP_TYPE = 'satellite';

export type MapType = typeof ROAD_MAP_TYPE | typeof SATELLITE_MAP_TYPE;

export const MAP_CONFIGURATION = {
  [ROAD_MAP_TYPE]: {
    style: 'mapbox://styles/mapbox/streets-v12',
  },
  [SATELLITE_MAP_TYPE]: {
    style: 'mapbox://styles/mapbox/satellite-streets-v12',
  },
};

export const TRAFFIC_LAYER_STYLE: LineLayerSpecification = {
  id: 'traffic',
  source: 'mapbox-traffic',
  'source-layer': 'traffic',
  type: 'line',
  paint: {
    'line-width': 1.5,
    'line-color': [
      'case',
      ['==', 'low', ['get', 'congestion']],
      '#aab7ef',
      ['==', 'moderate', ['get', 'congestion']],
      '#4264fb',
      ['==', 'heavy', ['get', 'congestion']],
      '#ee4e8b',
      ['==', 'severe', ['get', 'congestion']],
      '#b43b71',
      '#000000',
    ],
  },
};

export const PATH_LAYER_STYLE: LineLayerSpecification = {
  id: 'path-layer',
  source: 'path',
  type: 'line',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#000',
    'line-width': 8,
  },
};

export const PATH_ARROW_LAYER_STYLE: SymbolLayerSpecification = {
  id: 'path-arrow',
  type: 'symbol',
  source: 'path',
  layout: {
    'symbol-placement': 'line',
    'symbol-spacing': 3,
    'icon-image': 'arrow',
    'icon-size': 0.3,
  },
  paint: {
    'icon-opacity': 1,
  },
};

export const PATH_POINTS_LAYER_STYLE: CircleLayerSpecification = {
  id: 'path-point',
  type: 'circle',
  source: 'path',
  paint: {
    'circle-color': '#ffffff',
    'circle-radius': 2.5,
    'circle-stroke-color': '#000000',
    'circle-stroke-width': 4,
  },
  minzoom: 12,
  maxzoom: 19,
};
